import Vue from 'vue';
import state from '../state';
import noty from './noty.service';

export default {
  async getByClient(clientId, filter) {
    return (await Vue.http.post(`/api/agents/byclient/${clientId}`, filter)).data;
  },
  async getStatsByClient(clientId) {
    return (await Vue.http.get(`/api/agents/byclient/${clientId}/stats`)).data;
  },
  async load(agentId) {
    const editAgent = state.editAgent.get();
    agentId = agentId || (editAgent ? editAgent.id : false);
    if (!agentId) return null;
    const agent = (await Vue.http.get(`/api/agents/get/${agentId}`)).data;
    state.editAgent.set(agent);
  },
  async create(agent) {
    let p = (await Vue.http.post('/api/agents/create', agent)).data;
    noty.success('Agent created successfully');
    return p;
  },
  async checkUsername(username, clientId) {
    return (await Vue.http.post('/api/agents/check/username', { username, clientId })).data;
  },
  async save(agent) {
    let p = (await Vue.http.post('/api/agents/save', agent)).data;
    noty.success('Agent saved successfully');
    return p;
  },
  async lock(agentId) {
    let p = (await Vue.http.post(`/api/agents/lock/${agentId}`)).data;
    noty.success('Agent locked successfully');
    return p;
  },
  async unlock(agentId) {
    let p = (await Vue.http.post(`/api/agents/unlock/${agentId}`)).data;
    noty.success('Agent unlocked successfully');
    return p;
  }
}



// WEBPACK FOOTER //
// ./src/services/agent.service.js